import * as Yup from 'yup';
import { REQUIRED_FIELD } from 'src/constants';

const validEmailExceptions = ['na', 'n/a'];

const donorScreeningValidationSchema = Yup.object().shape({
  referralTemplateTypeId: Yup.string().nullable().required(REQUIRED_FIELD),
  kins: Yup.array()
    .nullable()
    .of(
      Yup.object().shape({
        email: Yup.string()
          .nullable()
          .transform((value) => (value === '' ? null : value))
          .test('email-or-na', 'Invalid email address', function (value) {
            if (!value) return true;

            const normalizedValue = value.trim().toLowerCase();

            if (validEmailExceptions.includes(normalizedValue)) {
              return true;
            }

            return Yup.string().email().isValidSync(value);
          }),
        mainPhone: Yup.string()
          .nullable()
          .transform((value) => {
            const trimmed = typeof value === 'string' ? value.trim() : value;
            return trimmed === '' ? null : trimmed;
          })
          .test(
            'numeric-only',
            'Phone number must be numeric values only',
            (value) => {
              if (!value) return true;
              return /^\d+$/.test(value);
            },
          )
          .when('mainPhoneCountryCodeId', {
            is: (countryCodeId) => Number(countryCodeId) === 1,
            then: (schema) =>
              schema.length(10, 'Phone number must be 10 digits'),
            otherwise: (schema) => schema,
          }),
        otherPhone: Yup.string()
          .nullable()
          .transform((value) => {
            const trimmed = typeof value === 'string' ? value.trim() : value;
            return trimmed === '' ? null : trimmed;
          })
          .test(
            'numeric-only',
            'Phone number must be numeric values only',
            (value) => {
              if (!value) return true;
              return /^\d+$/.test(value);
            },
          )
          .when('otherPhoneCountryCodeId', {
            is: (countryCodeId) => Number(countryCodeId) === 1,
            then: (schema) =>
              schema.length(10, 'Phone number must be 10 digits'),
            otherwise: (schema) => schema,
          }),
      }),
    ),
});

export default donorScreeningValidationSchema;
